/**
 * Where the wizard drops you after a first subscribe.
 *
 * Mirrors TopNavigation's logo target — on the MDM-only OptiEdge variant the signage nav is
 * hidden entirely, so /app/screenManagement is not a place to land someone.
 *
 * Its own module, rather than inline in the close handler, so the variant rule stays testable
 * without standing up the whole wizard hook.
 */
import type { AppVariant } from '@/lib/app-variant';

export function postSubscribeLandingPath(variant: AppVariant): string {
  return variant === 'optiedge' ? '/app/mdm' : '/app/screenManagement';
}
